module.exports = __webpack_public_path__ + "media/empty-states/badges-c0edf853.png";